import React from 'react'

const Scholarship = () => {
  return (
    <div>Scholarship</div>
  )
}

export default Scholarship